import { useEffect } from "react";
import { AppLayout } from "layouts";
import SurveyList from "components/SurveyList";
import Searchbar from "./components/Searchbar";
import { useDispatch, useSelector } from "store";
import { listSurveys, selectSurveyList, deleteSurvey } from "services/survey";

const Dashboard = () => {
  const dispatch = useDispatch();
  const surveys = useSelector(selectSurveyList);
  const handleDeleteSurvey = (surveyId: string) => {
    dispatch(deleteSurvey(surveyId));
  };
  useEffect(() => {
    dispatch(listSurveys());
  }, []);
  return (
    <AppLayout>
      <div className="container flex mx-auto flex-col items-center pt-ld-32 px-ld-16 md:px-ld-32">
        <Searchbar />
        <SurveyList surveys={surveys} onDeleteSurvey={handleDeleteSurvey} />
      </div>
    </AppLayout>
  );
};

export default Dashboard;
